var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArnnoldLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "164.94059405940556 133.95130804584358 113.51485148514865 146.2764026402641",
    width: 107.51,
    height: 142.28,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M169.26 204.78C169.36 204.78 169.44 204.86 169.44 204.96C169.44 211.63 169.44 231.44 169.44 238.11C169.44 238.21 169.36 238.28 169.26 238.28C169 238.28 168.38 238.28 168.12 238.28C168.02 238.28 167.94 238.21 167.94 238.11C167.94 231.44 167.94 211.63 167.94 204.96C167.94 204.86 168.02 204.78 168.12 204.78C168.38 204.78 169 204.78 169.26 204.78Z",
    id: "b3iMAh5qoE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.76 183.17C266.39 183.17 268.51 185.29 268.51 187.92C268.51 205.78 268.51 254.62 268.51 272.48C268.51 275.1 266.39 277.23 263.76 277.23C245.9 277.23 197.07 277.23 179.21 277.23C176.58 277.23 174.46 275.1 174.46 272.48C174.46 254.62 174.46 205.78 174.46 187.92C174.46 185.29 176.58 183.17 179.21 183.17C197.07 183.17 245.9 183.17 263.76 183.17Z",
    id: "d3JipndolV"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.46 221.53C272.46 234.51 261.92 245.05 248.94 245.05C235.96 245.05 225.43 234.51 225.43 221.53C225.43 208.56 235.96 198.02 248.94 198.02C261.92 198.02 272.46 208.56 272.46 221.53Z",
    id: "a22VnXj146"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.15 221.53C217.15 234.51 206.61 245.05 193.63 245.05C180.66 245.05 170.12 234.51 170.12 221.53C170.12 208.56 180.66 198.02 193.63 198.02C206.61 198.02 217.15 208.56 217.15 221.53Z",
    id: "a9fHZ9chk"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.75 157.28C227.75 160.74 224.94 163.55 221.49 163.55C218.03 163.55 215.22 160.74 215.22 157.28C215.22 153.83 218.03 151.02 221.49 151.02C224.94 151.02 227.75 153.83 227.75 157.28Z",
    id: "c7FoHNknn"
  }), /*#__PURE__*/React.createElement("path", {
    d: "",
    id: "fnf6uEoc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.49 183.17L221.49 162.25",
    id: "a878S79XwK"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.9 221.53C199.9 224.99 197.09 227.8 193.63 227.8C190.18 227.8 187.37 224.99 187.37 221.53C187.37 218.08 190.18 215.27 193.63 215.27C197.09 215.27 199.9 218.08 199.9 221.53Z",
    id: "f5KjxZ2RTJ"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.21 221.53C255.21 224.99 252.4 227.8 248.94 227.8C245.48 227.8 242.68 224.99 242.68 221.53C242.68 218.08 245.48 215.27 248.94 215.27C252.4 215.27 255.21 218.08 255.21 221.53Z",
    id: "b1cTr1Bnkn"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.63 218.89C189.63 217.86 190.47 217.02 191.5 217.02C192.53 217.02 193.37 217.86 193.37 218.89C193.37 219.92 192.53 220.75 191.5 220.75C190.47 220.75 189.63 219.92 189.63 218.89Z",
    id: "a1uhV0OihF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.21 218.89C245.21 217.86 246.04 217.02 247.07 217.02C248.1 217.02 248.94 217.86 248.94 218.89C248.94 219.92 248.1 220.75 247.07 220.75C246.04 220.75 245.21 219.92 245.21 218.89Z",
    id: "l1iwRSUVUc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.07 257.33C238.97 262.44 230.44 265 221.49 265C212.53 265 203.16 262.44 193.37 257.33",
    id: "a2eNQKAw8k"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.09 157.28L209.76 157.28",
    id: "c1mX1NISeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.49 134.95L221.49 145.62",
    id: "a1Igheb9YC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.08 137.67L227.75 146.9",
    id: "i1J7y0Ujqb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.37 146.62L232.13 151.95",
    id: "c2Y44HOlKP"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.75 157.95L233.08 157.95",
    id: "aGGTH3yu"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.37 168.88L232.13 163.55",
    id: "ahH7UEJu"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.37 150.95L202.13 145.62",
    id: "a8qrk3h2W"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.22 146.9L209.89 137.67",
    id: "a14hKG63H8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.55 163.25L202.32 168.58",
    id: "e2diw62ni3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.28 204.78C275.38 204.78 275.46 204.86 275.46 204.96C275.46 211.63 275.46 231.44 275.46 238.11C275.46 238.21 275.38 238.28 275.28 238.28C275.01 238.28 274.4 238.28 274.13 238.28C274.03 238.28 273.96 238.21 273.96 238.11C273.96 231.44 273.96 211.63 273.96 204.96C273.96 204.86 274.03 204.78 274.13 204.78C274.4 204.78 275.01 204.78 275.28 204.78Z",
    id: "d4Jsvlo3jJ"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b3iMAh5qoE",
    opacity: 1,
    fill: "#20718c",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b3iMAh5qoE",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#20718c",
    strokeWidth: 6,
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d3JipndolV",
    opacity: 1,
    fill: "#32aed8",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d3JipndolV",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#20718c",
    strokeWidth: 5,
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a22VnXj146",
    opacity: 1,
    fill: "#ffffff",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a22VnXj146",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#20718c",
    strokeWidth: 5,
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a9fHZ9chk",
    opacity: 1,
    fill: "#ffffff",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a9fHZ9chk",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#20718c",
    strokeWidth: 5,
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c7FoHNknn",
    opacity: 1,
    fill: "#ffffff",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c7FoHNknn",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#20718c",
    strokeWidth: 5,
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fnf6uEoc",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#20718c",
    strokeWidth: 6,
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a878S79XwK",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#20718c",
    strokeWidth: 5,
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f5KjxZ2RTJ",
    opacity: 1,
    fill: "#20718c",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f5KjxZ2RTJ",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#20718c",
    strokeWidth: 5,
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b1cTr1Bnkn",
    opacity: 1,
    fill: "#20718c",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b1cTr1Bnkn",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#20718c",
    strokeWidth: 5,
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1uhV0OihF",
    opacity: 1,
    fill: "#ffffff",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1uhV0OihF",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#ffffff",
    strokeWidth: 5,
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l1iwRSUVUc",
    opacity: 1,
    fill: "#ffffff",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l1iwRSUVUc",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#ffffff",
    strokeWidth: 5,
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a2eNQKAw8k",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#20718c",
    strokeWidth: 5,
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c1mX1NISeb",
    opacity: 1,
    fill: "#86adba",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c1mX1NISeb",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#86adba",
    strokeWidth: 1,
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1Igheb9YC",
    opacity: 1,
    fill: "#86adba",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1Igheb9YC",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#86adba",
    strokeWidth: 1,
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#i1J7y0Ujqb",
    opacity: 1,
    fill: "#86adba",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#i1J7y0Ujqb",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#86adba",
    strokeWidth: 1,
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c2Y44HOlKP",
    opacity: 1,
    fill: "#86adba",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c2Y44HOlKP",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#86adba",
    strokeWidth: 1,
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aGGTH3yu",
    opacity: 1,
    fill: "#86adba",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aGGTH3yu",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#86adba",
    strokeWidth: 1,
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ahH7UEJu",
    opacity: 1,
    fill: "#86adba",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ahH7UEJu",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#86adba",
    strokeWidth: 1,
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a8qrk3h2W",
    opacity: 1,
    fill: "#86adba",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a8qrk3h2W",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#86adba",
    strokeWidth: 1,
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a14hKG63H8",
    opacity: 1,
    fill: "#86adba",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a14hKG63H8",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#86adba",
    strokeWidth: 1,
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e2diw62ni3",
    opacity: 1,
    fill: "#86adba",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e2diw62ni3",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#86adba",
    strokeWidth: 1,
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d4Jsvlo3jJ",
    opacity: 1,
    fill: "#20718c",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d4Jsvlo3jJ",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#20718c",
    strokeWidth: 6,
    strokeOpacity: 1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArnnoldLogo);
export default __webpack_public_path__ + "static/media/arnnoldLogo.d71d00801c5d26087c1b85d9d1d81d3d.svg";
export { ForwardRef as ReactComponent };